import React from "react";
import Swiper from "react-id-swiper";

const ShopCategoryBanners = ({ banners }) => {
  const params = {
    effect: "fade",
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    watchSlidesVisibility: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    renderPrevButton: () => (
      <button className="swiper-button-prev ht-swiper-button-nav">
        <i className="pe-7s-angle-left" />
      </button>
    ),
    renderNextButton: () => (
      <button className="swiper-button-next ht-swiper-button-nav">
        <i className="pe-7s-angle-right" />
      </button>
    ),
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  };

  return (
    <div className="slider-area">
      <div className="slider-active nav-style-1 shop-category-banner-wrapper">
        {Array.isArray(banners) && banners.length > 0 && (
          <Swiper {...params} rebuildOnUpdate>
            {banners.map(({ media: { fileUrl }, url }) => (
              <div
                className="shop-category-banner"
                onClick={() => {
                  if (url) window.location.href = url;
                }}
              >
                <img src={fileUrl} />
              </div>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
};

export default ShopCategoryBanners;
